// extracted by mini-css-extract-plugin
export var stepActive = "_2g-3";
export var stepCompleted = "_2g-4";
export var stepConnectorLine = "_2g-b";
export var stepIndicatorCircle = "_2g-6";
export var stepIndicatorCircleCompleted = "_2g-7";
export var stepIndicatorCircleDefault = "_2g-8";
export var stepIndicatorTextCompleted = "_2g-9";
export var stepIndicatorTextDefault = "_2g-a";
export var stepPending = "_2g-5";
export var wizardContainer = "_2g-1";
export var wizardContent = "_2g-2";
export var wizardModal = "_2g-0";